import { render, staticRenderFns } from "./misDatos.vue?vue&type=template&id=dbbd6f4c&"
import script from "./misDatos.vue?vue&type=script&lang=ts&"
export * from "./misDatos.vue?vue&type=script&lang=ts&"
import style0 from "./misDatos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports